import artwork194537 from "../../../assets/curation/4/194537.jpg";
import artwork304118 from "../../../assets/curation/4/304118.jpg";
import artwork314521 from "../../../assets/curation/4/314521.jpg";
import artwork349588 from "../../../assets/curation/4/349588.jpg";
import artwork351731 from "../../../assets/curation/4/351731.jpg";
import artwork187615 from "../../../assets/curation/4/187615.jpg";
import artwork157467 from "../../../assets/curation/4/157467.jpg";

const data = {
  title: "FOCUSED",
  subtitle: "PRISMA #5",
  curated: "Curated by<br/>Kinnara : Desi La",
  description: `
  These collected artists are like scientists collecting data and combing
for only the most necessary of elements to create both sharp observations 
on society and diagnoses on the concurring illnesses we suffer from. 
In this time of Covid, these artists have their eyes on our greater future. 
They are the most focused.
  `,
  artists: [
    {
      artist: ["hungyuhao"],
      title: "Enum in City",
      profile: ["tz1TtUyR5URy2rGZS9pV8JT8TuhixiEPf3xF"],
      description: `This project focuses on the life in the old neighborhoods. In this block, there are some public housing building by early government. 
      The space is small to accommodate the people of the low- and middle-income class, but the living functions are self-contained in the community. 
      Nowadays, this community is attached to the stars like a planet in the bustling city, but operates alone.`,
      objktID: 194537,
      artwork: artwork194537,
    },
    {
      artist: ["yluztra"],
      title: "KORAL #19",
      profile: ["tz1NcMLkFhHGnfCch4GX5nSGJ6pY7797iofp"],
      description: `Koral Series NFT, by @yluztra.`,
      objktID: 304118,
      artwork: artwork304118,
    },
    {
      artist: ["Rimbawan Gerilya"],
      title: "Loud and Clear",
      profile: ["tz1TKzJHSyv7ChziiBsPetmLFDYBpVZeSyKt"],
      description: `Message of the past, well-preserved and amplified.
      Made while having a fever from 2nd Covid vaccine shot.
      Watch while listening to Fatima Al Qadiri for extra immersion.`,
      objktID: 314521,
      artwork: artwork314521,
    },
    {
      artist: ["grasshopper"],
      title: "PELANGI BESI V1",
      profile: ["tz1MrdUczWDFB2445fCgqKexWvBK9wRZUWni"],
      description: `PELANGI BESI (RAINBOW STEEL) An organic iridescent metal. 

      Series of digital art created using Cinema 4D.
      `,
      objktID: 349588,
      artwork: artwork349588,
    },
    {
      artist: ["sanjonas"],
      title: "Woods Against Eternity",
      profile: ["tz1WFmEdGNZ9FXjMepfiXbHea3AcVE5fNrs9"],
      description: `It's lost & found track, back in 2019. This track was originally produced for "KANON EP" but unluckily my laptop died. The master file got corrupted and the vst files are missing. With only a draft wav file, rework it again and remastered it. 
      And, Voila~ 
      
      Let us dive into remnants of the post-apocalyptic world controlled by gigantic plants, and mutated survivors.
      
      [Collect and you can get the audio file upon request. For personal non-commercial use]
      `,
      objktID: 351731,
      artwork: artwork351731,
    },
    {
      artist: ["violetforest"],
      title: "Petals, Leaves, Crystals, Fur, Bunnies",
      profile: ["tz1YMqQQme7jcERyk2586QDT9fqWGCz9L2fQ"],
      description: `organic matter`,
      objktID: 187615,
      artwork: artwork187615,
    },
    {
      artist: ["Babepr33"],
      title: "Cybabe 04",
      profile: ["tz1Kitqgc5Mw43boAgFtU92kPAMocJekedkE"],
      description: `this babe is banished from her land, becomes addicted to green where they locked her, to rule once and forever`,
      objktID: 157467,
      artwork: artwork157467,
    },
  ],
};

export default data;
